define([
  "marionette",
  "./template/notificationsTemplate.html",
  "modules/admin/userAdmin/notifications/notificationModel",
], function (Marionette, NotificationsTemplate, NotificationModel) {
  "use strict";

  return {
    view: Marionette.Layout.extend({
      className: "form-horizontal",
      template: NotificationsTemplate,
      regions: {
        notificationsList: "#notificationsList",
      },
    }),
  };
});
